import shopifyGenericDefaults from '../shopify-generic/config.js';

const onDropdownItemsReceived = shopifyGenericDefaults.Widgets.find(
  (w) => w.name === 'SearchBox',
).onDropdownItemsReceived?.();

export default {
  includes: ['shopify-generic'],
  ...shopifyGenericDefaults,
  fitmentSearch: {
    ...shopifyGenericDefaults.fitmentSearch,
    isExtraFieldsAlwaysVisible: true,
  },
  product: {
    ...shopifyGenericDefaults.product,
    dropdownImageWidth: 80,
    dropdownImageHeight: 80,
  },
  Widgets: [
    ...shopifyGenericDefaults.Widgets.filter(
      (w) => !['SearchBox', 'FacetDialog', 'FacetVehicleWidget'].includes(w.name),
    ),
    {
      name: 'SearchBox',
      type: 'SearchBoxDialogButton',
      location: { selector: '#cm-search-box', class: 'cm-search-box' },
      onDropdownItemsReceived,
      onSubmit: () =>
        window.document.querySelector('.site-header__search predictive-search .btn--close-search')?.click(),
      template: 'searchBox/dialogButtonAdaptable',
    },
    {
      name: 'FacetDialog',
      template: 'FacetDialog',
      initCollapsed: false,
    },
    {
      name: 'FacetVehicleWidget',
      type: 'VehicleWidget',
      isAlwaysActive: true,
      isAlwaysColumnLayout: true,
    },
  ],
};
